import useSWR from "swr"
import { SizeScaleApi } from "../../../apis"

export function useSizeDefinitionsQuery (sizeScaleId: string | null | undefined) {
  const cacheKey = sizeScaleId
    ? ([`size-definitions:${sizeScaleId}`, sizeScaleId] as const)
    : null

  const { data, isLoading, error, mutate } = useSWR(
    cacheKey,
    async ([, id]) => SizeScaleApi.definitions.list(id),
    { revalidateOnFocus: false }
  )

  return {
    rows : data?.rows ?? [],
    count: data?.count ?? 0,
    isLoading,
    error,
    mutate,
  }
}
